import React from "react";
import PdfViewer from "../comman/PdfViewer";
import { marketingDocs } from "../consfig";

const SalesDeck = () => {
  const pdfUrl = marketingDocs.salesDeck;

  return <PdfViewer pdfFile={pdfUrl} />;
};

export default SalesDeck;
